<h1 mat-dialog-title>
  Documentos del colaborador
</h1>

<hr>

<mat-dialog-content>

  <div class="table-responsive">

    <table
      mat-table
      [dataSource]="dataSourceDocumentos"
      matSort
      #sortDocumentos="matSort">

      <ng-container matColumnDef="item">
        <th mat-header-cell *matHeaderCellDef>
          #
        </th>

        <td mat-cell *matCellDef="let row; let i = index">
          {{ i + 1 }}
        </td>
      </ng-container>

      <ng-container matColumnDef="nombreDocumento">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header>

          Documento

        </th>

        <td mat-cell *matCellDef="let row">
          {{ row.nombre }}
        </td>
      </ng-container>

      <ng-container matColumnDef="options">

        <th mat-header-cell *matHeaderCellDef>
          Acciones
        </th>

        <td mat-cell *matCellDef="let row">

          <button
            mat-icon-button
            color="primary"
            (click)="downloadDocument(row)"
            aria-label="Descargar">

            <mat-icon>
              download
            </mat-icon>

          </button>

        </td>

      </ng-container>

      <tr
        mat-header-row
        *matHeaderRowDef="displayedColumnsDocumentos">
      </tr>

      <tr
        mat-row
        *matRowDef="
          let row;
          columns: displayedColumnsDocumentos
        ">
      </tr>

    </table>

  </div>

  <mat-paginator
    #paginatorDocumentos
    [pageSize]="10"
    [pageSizeOptions]="[10,20,50]"
    showFirstLastButtons>
  </mat-paginator>

</mat-dialog-content>

<mat-dialog-actions align="end">

  <button
    mat-raised-button
    color="warn"
    (click)="close()">

    <mat-icon>
      close
    </mat-icon>

    Cerrar

  </button>

</mat-dialog-actions>